import { isDemoInstance } from '../../utils/';

const CustomizeView = () => (
	<a href="/api/" target="_blank" rel="noreferrer" className={isDemoInstance() ? 'hide' : ''}>
		<button className="button-sm btn-orange">Admin</button>
	</a>
);

export default CustomizeView;
